import { render, staticRenderFns } from "./Border.vue?vue&type=template&id=6bd10b24&scoped=true"
import script from "./Border.vue?vue&type=script&lang=js"
export * from "./Border.vue?vue&type=script&lang=js"
import style0 from "./Border.vue?vue&type=style&index=0&id=6bd10b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd10b24",
  null
  
)

export default component.exports